export const getInt = (value) => {
  if (typeof value !== 'number') {
    return parseInt(value, 10);
  }
  return value;
};

export const getFloat = (value) => {
  if (typeof value !== 'number') {
    const floatValue = parseFloat(value.replace(',', '.'));
    if (typeof value === 'string' && floatValue) {
      return floatValue;
    }
    return 0;
  }
  return value;
};

export const getDecimal = value => Number(`${Math.round(`${getFloat(value)}e2`)}e-2`);
